import { onImageFractionInput } from '@utils/component-framework';
import { NoSSR } from '@utils/react';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { useInputState } from '../../hook.use-input-state.js';
import { StateBox } from '../atom.state-box/_state-box.js';
import { TextInput } from '../write-answers.in-text/atom.text-input.js';
import { tokens, wrapper, stateBox, readonlyNumber, fraction, readonlyFractionValue } from './input.fraction.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function OnImageFractionInput(props) {
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => onImageFractionInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.input.id])
  });
  const onChange = (evt, target) => {
    update(props.taskEntryKey, props.input.id, {
      type: "on-image-fraction",
      denominator: "",
      number: "",
      numerator: "",
      ...inputEntry,
      [target]: evt.currentTarget.value ?? ""
    });
  };
  const state = useInputState(props.input, inputEntry);
  if (state !== "input") {
    const facitState = state === "incorrect" && props.facitType === "should-have" ? "should-have" : state;
    const value = props.facitType === "should-have" ? props.input.validation.correctAnswers[0] : inputEntry;
    return /*#__PURE__*/jsx("div", {
      className: wrapper,
      style: tokens.__override({
        x: `${props.input.placement.x * 100}%`,
        y: `${props.input.placement.y * 100}%`,
        scale: props.scale
      }),
      children: /*#__PURE__*/jsxs(StateBox, {
        state: facitState,
        className: stateBox,
        children: [!props.input.styling.hideNumber && /*#__PURE__*/jsx("span", {
          className: readonlyNumber,
          children: value?.number
        }), (value?.numerator || value?.denominator) && /*#__PURE__*/jsxs("div", {
          className: fraction,
          children: [/*#__PURE__*/jsx("span", {
            className: readonlyFractionValue,
            children: value?.numerator
          }), /*#__PURE__*/jsx("span", {
            className: readonlyFractionValue,
            children: value?.denominator
          })]
        })]
      })
    });
  } else {
    return /*#__PURE__*/jsx(NoSSR, {
      children: /*#__PURE__*/jsxs("div", {
        className: wrapper,
        style: tokens.__override({
          x: `${props.input.placement.x * 100}%`,
          y: `${props.input.placement.y * 100}%`,
          scale: props.scale
        }),
        children: [!props.input.styling.hideNumber && /*#__PURE__*/jsx(TextInput, {
          value: inputEntry?.number,
          state: state,
          onChange: evt => onChange(evt, "number"),
          inputMode: "numeric"
        }), /*#__PURE__*/jsxs("div", {
          className: fraction,
          children: [/*#__PURE__*/jsx(TextInput, {
            value: inputEntry?.numerator,
            state: state,
            onChange: evt => onChange(evt, "numerator"),
            inputMode: "numeric"
          }), /*#__PURE__*/jsx(TextInput, {
            value: inputEntry?.denominator,
            state: state,
            onChange: evt => onChange(evt, "denominator"),
            inputMode: "numeric"
          })]
        })]
      })
    });
  }
}

export { OnImageFractionInput };
//# sourceMappingURL=input.fraction.js.map
